// ======================================================================
// File Name       : SelectGroupModalContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { change } from 'redux-form';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../../constants/index';
import TreeView from '../../components/Tree';
import ModalWrapper from '../../components/modal/ModalWrapper';
import * as groupActions from '../../actions/GroupAction';
import * as ServiceAction from '../../actions/ServiceAction';
import * as csvDownloadActionCreators from '../../actions/actionCreators/csvDownload';
import * as Functions from '../../constants/FunctionConstants';
import TREE_ICON from '../../images/tree/default-icon.png';
import { canAccess } from '../../utils/AuthedUtils';
import RenderField from '../../utils/ReduxFormUtils';
import { createTree } from '../../utils/groupUtils';

class SelectGroupModalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.checkCreateTree = this.checkCreateTree.bind(this);
    this.onOKForCSV = this.onOKForCSV.bind(this);
    this.onCancelForCSV = this.onCancelForCSV.bind(this);
  }

  componentWillMount() {
    if (!this.props.allSecernIds || !this.props.bySecernId || this.props.allSecernIds.length <= 0) {
      this.props.dispatch(groupActions.fetchGroupStructure());
    }
    this.props.dispatch(ServiceAction.removedAllUserByGroup());
  }

  onOK() {
    const { formKey, userType } = this.props;
    const form = this.props.form[formKey];
    if (form && form.values) {
      const { selectedTargetGroupIds } = form.values;
      this.props.dispatch(ServiceAction.addUsersByGroups(userType, selectedTargetGroupIds)).then(() => {
        this.props.dispatch(change(this.props.formKey, 'selectedTargetGroupIds', null));
        this.props.hideModal();
      });
    } else {
      this.props.dispatch(change(this.props.formKey, 'selectedTargetGroupIds', null));
      this.props.hideModal();
    }
  }

  onCancel() {
    this.props.dispatch(change(this.props.formKey, 'selectedTargetGroupIds', null));
    this.props.hideModal();
  }

  checkCreateTree() {
    const { isOpenSelectGroup, isLearningHistoryCSVPage } = this.props.csvDownload;
    const { groupList } = this.props;
    let selectedTargetGroupIds = this.props.selectedTargetGroupIds;
    if (isOpenSelectGroup) {
      if (this.props.form
        && this.props.form.progressStatusCSVDownload
        && this.props.form.progressStatusCSVDownload.values
        && this.props.form.progressStatusCSVDownload.values.selectedTargetGroupIds) {
        selectedTargetGroupIds = this.props.form.progressStatusCSVDownload.values.selectedTargetGroupIds;
      }
      if (isLearningHistoryCSVPage) {
        if (this.props.form
          && this.props.form.learningHistoryCSV
          && this.props.form.learningHistoryCSV.values
          && this.props.form.learningHistoryCSV.values.selectedTargetGroupIds) {
          selectedTargetGroupIds = this.props.form.learningHistoryCSV.values.selectedTargetGroupIds;
        }
      }
    }
    return createTree(groupList, true, selectedTargetGroupIds);
  }

  onOKForCSV() {
    let selectedGroupList = [];
    const { isLearningHistoryCSVPage } = this.props.csvDownload;
    if (isLearningHistoryCSVPage) {
      this.props.form.learningHistoryCSV.values.selectedTargetGroupIds &&
      (selectedGroupList = [...this.props.form.learningHistoryCSV.values.selectedTargetGroupIds]);
    } else {
      this.props.form.progressStatusCSVDownload.values.selectedTargetGroupIds &&
      (selectedGroupList = [...this.props.form.progressStatusCSVDownload.values.selectedTargetGroupIds]);
    }

    this.props.dispatch(csvDownloadActionCreators.receiveSelectedGroupList(selectedGroupList));
    this.props.hideModal();
  }

  onCancelForCSV() {
    const { csvDownload } = this.props;
    const { learningHistoryCSVDownload } = csvDownload;
    const { selectedGroup } = learningHistoryCSVDownload;

    this.props.dispatch(csvDownloadActionCreators.changeShowGroupFlag(true));
    this.props.dispatch(change('learningHistoryCSV', 'selectedTargetGroupIds', [...selectedGroup]));
    this.props.hideModal();
  }

  getModalOptions() {
    const { isOpenSelectGroup } = this.props.csvDownload;
    if (isOpenSelectGroup) {
      return {
        title: 'ユーザーグループを選択してください',
        footerBtns: [
          { name: 'キャンセル', onClick: this.onCancelForCSV, variant: 'default' },
          { name: 'OK', onClick: this.onOKForCSV, variant: 'primary' },
        ],
      };
    }
    return {
      title: 'ユーザーグループを選択してください',
      footerBtns: [
        { name: 'キャンセル', onClick: this.onCancel, variant: 'default' },
        { name: 'OK', onClick: this.onOK, variant: 'primary' },
      ],
    };
  }

  render() {
    const nodes = this.checkCreateTree();
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.onCancel}>
        <Col sm={12}>
          <RenderField name={'selectedTargetGroupIds'} data={nodes} type="tree" treeCheckBox />
        </Col>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { selectedTargetGroupIds } = state.group;
  const { structures, groupList } = state.group;
  const form = state.form;
  const { csvDownload } = state;
  return { selectedTargetGroupIds, form, ...structures, csvDownload, groupList };
};

export default connect(mapStateToProps)(SelectGroupModalContainer);
